import { useMemo } from 'react';
import {
  useComparingConversationsParams,
  useCurrentConversation,
} from 'src/hooks';

export const useComparingConversations = () => {
  const { firstComparedConvId, secondComparedConvId } =
    useComparingConversationsParams();

  const {
    currentConversation: firstConversationData,
    isCurrentConversationLoading: isFirstConversationLoading,
    isConversationSuccess: isFirstConversationSuccess,
  } = useCurrentConversation(firstComparedConvId);

  const {
    currentConversation: secondConversationData,
    isCurrentConversationLoading: isSecondConversationLoading,
    isConversationSuccess: isSecondConversationSuccess,
  } = useCurrentConversation(secondComparedConvId);

  const isComparingConversationsSuccess =
    isFirstConversationSuccess && isSecondConversationSuccess;

  const isComparingConversationsLoaded =
    firstComparedConvId &&
    secondComparedConvId &&
    !!firstConversationData &&
    !!secondConversationData;

  return useMemo(
    () => ({
      firstConversationData,
      secondConversationData,
      firstLinkedConversationId: firstConversationData?.linked_conversation_id,
      secondLinkedConversationId:
        secondConversationData?.linked_conversation_id,
      isFirstConversationLoading,
      isSecondConversationLoading,
      isComparingConversationsLoaded,
      isComparingConversationsSuccess,
    }),
    [
      firstConversationData,
      secondConversationData,
      isFirstConversationLoading,
      isSecondConversationLoading,
      isComparingConversationsLoaded,
      isComparingConversationsSuccess,
    ],
  );
};
